/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUPS from application-types instead.
 */
export const TYPE_GROUPS = [
  'Text',
  'Number',
  'Media',
  'Lane',
  'Other',
  'Time',
  'Integration',
] as const;

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_TEXT from application-types instead.
 */
export const TYPE_GROUP_TEXT = TYPE_GROUPS[0];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_NUMBER from application-types instead.
 */
export const TYPE_GROUP_NUMBER = TYPE_GROUPS[1];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_MEDIA from application-types instead.
 */
export const TYPE_GROUP_MEDIA = TYPE_GROUPS[2];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_LANE from application-types instead.
 */
export const TYPE_GROUP_LANE = TYPE_GROUPS[3];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_OTHER from application-types instead.
 */
export const TYPE_GROUP_OTHER = TYPE_GROUPS[4];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_TIME from application-types instead.
 */
export const TYPE_GROUP_TIME = TYPE_GROUPS[5];

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use TYPE_GROUP_INTEGRATION from application-types instead.
 */
export const TYPE_GROUP_INTEGRATION = TYPE_GROUPS[6];
